import React, { useContext, useEffect, useState } from "react";
import { Form } from 'semantic-ui-react';
import { AdminContext } from "../../contexts/AdminContext";
import UploadLicenseDropzone from './UploadLicenseDropzone';

function License() {
    const [licensedTo, setLicensedTo] = useState<string>("");
    const [licenseDate, setLicenseDate] = useState<string>("");
    const [licenseExpiryDays, setLicenseExpiryDays] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");
    const { licenseSettings } = useContext(AdminContext);

    useEffect(() => {
        getLicenseSettings();
        
    }, [])

    const getLicenseSettings = () => {
        setLicensedTo(licenseSettings.licensedTo);
        setLicenseDate(licenseSettings.licenseDate);
        setLicenseExpiryDays(licenseSettings.licenseExpiryDays);
    }

    const fileChange = (event:any) => {
        const fileNameTemp = event.target.files[0]["name"];
        setFileName(fileNameTemp);
    }

    const getExpiryColour = () => {
        let expiryDays = licenseExpiryDays;
        let days = Number(expiryDays);

        if (days <= 10) {
            return (
                <div className="header gray" style={{ color: "red", marginLeft: 10, marginTop: 10 }} >YOUR LICENSE WILL EXPIRE IN {expiryDays} DAYS</div>
            )
        }
        else {
            return (
                <div className="header gray" style={{ color: "#5f5b58", marginLeft: 10, marginTop: 10 }} >YOUR LICENSE WILL EXPIRE IN {expiryDays} DAYS</div>
            )
        }
    }

    return (
        <div className="ui admin-container">

            <Form className="ui form" id="form-admin">
                <div className="header blue " style={{ color: "#5D7BB0", marginLeft: 10, marginTop: 5, marginBottom: 5 }} >License Details</div>

                <div className="header gray headerStyleGray" >LICENSED TO</div>
                <div style={{ marginLeft: 10, marginTop: 5 }}>{licensedTo}</div>

                <div className="header gray" style={{ color: "#5f5b58", marginLeft: 10, marginTop: 10 }} >CURRENT LICENSE EXPIRY</div>
                <div style={{ marginLeft: 10, marginTop: 5 }}>{licenseDate}</div>

                {getExpiryColour()}

                <div style={{ marginLeft: 10, marginTop: 5 }}>To renew your license contact FYB on 1800 392 392 or via email membershub@fyb.com.au</div>

                <div className="header gray " style={{ color: "#5f5b58", marginLeft: 10, marginTop: 10, marginBottom: 10 }} >UPLOAD LICENSE</div>
                <div className="meta" style={{ marginLeft: 10, marginBottom: 5 }}>Upload your new license below</div>
                <UploadLicenseDropzone style={{marginLeft: 10}} />
            </Form>
        </div>
    )

}

export default License;